export const TITLE_SCREEN = 'Title Screen';
export const GAME_SETTINGS_SCREEN = 'Game Settings Screen';
export const WELCOME_LETTER_SCREEN = 'Welcome Letter Screen';
export const SETTINGS_SCREEN = 'Settings Screen';
export const QUICKPLAY_SCREEN = 'Quickplay Screen';
export const MAIN_GAME_SCREEN = 'Main Game Screen';

export const PRESS_GAME_SCREEN = 'Press Game Screen';
export const MESSAGES_GAME_SCREEN = 'Messages Game Screen';
export const MEETINGS_GAME_SCREEN = 'Meetings Game Screen';
export const DEBATE_GAME_SCREEN = 'Debate Game Screen';
export const SPEAKER_GAME = 'Speaker Game';
export const INQUIRY_GAME_SCREEN = 'Inquiry Game Screen';
export const QUESTIONS_GAME_SCREEN = 'Questions Game Screen';
export const VOTE_GAME_SCREEN = 'Vote Game Screen';

export const TIME_PASSING_SCREEN = 'Time Passing Screen';
export const END_OF_DAY_SCREEN = 'End of Day Screen';
export const START_OF_DAY_SCREEN = 'Start of Day Screen';
